<template functional>
  <container-tasks
    :container="{ id: props.item.id, abbrev_type: props.item.abbrev_type }"
    :tasks="props.item.tasks"
  />
</template>

<script>
export default {
  name: "fltl-tasks",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
